import {Service} from "angular-ecmascript/module-helpers";
import ModalTemplate from "./customer-details.modal.html";

export let Name = 'customerDetailsModal';

export default class CustomerDetailsModal extends Service {
    static $name = Name;
    static $inject = ['$q', '$modalDelegate'];

    show(options) {
        this.$modalDelegate.show({
            scope: this.$scope,
            template: ModalTemplate,
            args: {
                customer: options.customer,
                editable: options.editable,
                withContactDivider: options.withContactDivider,
                withAddressDivider: options.withAddressDivider
            },

            onSave: (result) => {
                if (options.onSave) {
                    options.onSave(options.customer);
                }

                return result;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/customer-details/customer-details.modal.js